exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-box-navbar{max-width:100%!important;box-shadow:0 1px 8px 0 rgba(0,0,0,.2)}.search-box-navbar .v-form .input-container.origin{width:320px}.search-box-navbar .v-form .input-container.date,.search-box-navbar .v-form .input-container.travellers{width:220px}@media screen and (min-width:1280px){.search-box-navbar{flex-wrap:nowrap}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};